import { Box } from '@mui/material';
import PrivacyPolicyComponent from './PrivacyPolicyComponent';

export default function PrivacyPolicy() {
  return (
    <Box mt={['2.75rem', '2.75rem', '5.5625rem']}>
      <PrivacyPolicyComponent />
    </Box>
  );
}
